import { render, staticRenderFns } from "./imageModal.vue?vue&type=template&id=aaa4c064&scoped=true&"
import script from "./imageModal.vue?vue&type=script&lang=js&"
export * from "./imageModal.vue?vue&type=script&lang=js&"
import style0 from "./imageModal.vue?vue&type=style&index=0&id=aaa4c064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa4c064",
  null
  
)

export default component.exports